import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { InventoryMovement, InventoryMovementCreate, InventoryMovementFilter } from '../data/inventoryMovement';

export function createInventoryMovementService(client: AxiosInstance) {
  return createCrudService<InventoryMovement, InventoryMovementCreate, InventoryMovementFilter>(
    client,
    '/purchase/InventoryMovement',
    'id',
  );
}

export type InventoryMovementService = CrudService<InventoryMovement, InventoryMovementCreate, InventoryMovementFilter>;
